import { handleInputChange, numbersOnly } from "legacy/helpers.es6"
import { validatorFactory } from "legacy/validatorFactory"
import PropTypes from "prop-types"
import React from "react"

import Modal from "src/components/Modal"

import { stripePromise } from "src/utils/StripePromise"

// Note: The following globals are loaded from external scripts and not imported:
// - Stripe: Used for payment processing
// - $ (jQuery): Used for AJAX requests
// - Amplitude: Used for analytics tracking

class AddBankAccountModal extends React.Component {
  constructor(args) {
    super(args)
    this.state = {
      showModal: false,
    }
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleChangeBank = this.handleChangeBank.bind(this)
    this.handleConnectBank = this.handleConnectBank.bind(this)
    this.handleCloseModal = this.handleCloseModal.bind(this)
    this.save = this.save.bind(this)
    this.tooltip = this.tooltip.bind(this)
    this.validator = validatorFactory()
  }

  handleInputChange(event) {
    handleInputChange(this, event)
  }

  handleChangeBank(_event) {
    Amplitude.trackEvent(
      "stripe_connect_onboarding:change_bank_account_pressed"
    )
    this.setState({ showModal: true })
  }

  handleConnectBank(_event) {
    Amplitude.trackEvent(
      "stripe_connect_onboarding:connect_bank_account_pressed"
    )
    this.setState({ showModal: true })
  }

  handleCloseModal(_event) {
    Amplitude.trackEvent(
      "stripe_connect_onboarding:add_bank_account_cancel_pressed"
    )
    this.setState({ showModal: false })
  }

  save() {
    this.validator.showMessages()
    if (this.validator.allValid()) {
      this.setState({
        saving: true,
        validationErrorMessage: null,
      })
      this.tokenizeStripe()
    } else {
      this.forceUpdate()
    }
  }

  async tokenizeStripe() {
    const accountParams = {
      country: this.props.smaCountry.countryCode,
      currency: this.props.smaCountry.currencyCode,
      routing_number: this.state.routing_number,
      account_number: numbersOnly(this.state.account_number),
      account_holder_name: this.state.account_holder_name,
      account_holder_type: "company",
    }

    const stripe = await stripePromise
    stripe.createToken("bank_account", accountParams).then((result) => {
      if (result.error) {
        this.setState({
          saving: false,
          validationErrorMessage: result.error.message,
        })
      } else {
        $.post(
          this.props.route,
          { stripe_bank_token: result.token.id, _method: "patch" },
          () => {
            location.reload()
          }
        ).fail(() => {
          this.setState({
            saving: false,
            validationErrorMessage:
              "Something went wrong adding your bank to your Dockwa account.",
          })
        })
      }
    })
  }

  tooltip() {
    return (
      <i
        className="icon icon-md-info ml-2"
        data-toggle="tooltip"
        data-placement="top"
        title="Enter the location ID of the bank where you opened your account, known as a routing number in the US, and referred to as SWIFT code, BIC code, ABA, RTN, or IBAN outside the US"
      />
    )
  }

  bankAccountButton() {
    if (this.props.bankAccountAdded) {
      return (
        <button
          className="btn btn-secondary w-full"
          onClick={this.handleChangeBank}
          type="button"
        >
          Change Bank Account
        </button>
      )
    } else {
      return (
        <button
          className="btn btn-primary w-full"
          onClick={this.handleConnectBank}
          type="button"
        >
          Connect Bank Account
        </button>
      )
    }
  }

  render() {
    return (
      <div>
        {this.bankAccountButton()}
        <Modal
          isOpen={this.state.showModal}
          onClose={this.handleCloseModal}
          size="small"
        >
          <Modal.Header title="Add Bank Account" />
          <Modal.Body>
            <div className="form-group">
              <label>Account Holder Name</label>
              <input
                className="form-control"
                name="account_holder_name"
                onChange={this.handleInputChange}
              />
              {this.validator.message(
                "account_holder_name",
                this.state.account_holder_name,
                "required"
              )}
            </div>
            <div className="form-group">
              <label>
                Routing Number
                {this.tooltip()}
              </label>
              <input
                className="form-control"
                name="routing_number"
                onChange={this.handleInputChange}
              />
              {this.validator.message(
                "routing_number",
                this.state.routing_number,
                "required"
              )}
            </div>
            <div className="form-group">
              <label>Account Number</label>
              <input
                className="form-control"
                name="account_number"
                onChange={this.handleInputChange}
              />
              {this.validator.message(
                "account_number",
                this.state.account_number,
                "required"
              )}
            </div>
            {this.validator.messageWhenPresent(
              this.state.validationErrorMessage
            )}
            <hr />
            <div className="text-muted bs-mb-3">
              Example of how to find your bank&apos;s routing and account number
              on a check. It can also usually be found through your bank&apos;s
              website or app.
            </div>
            <img className="w-full" src={this.props.checkImageUrl} />
          </Modal.Body>
          <Modal.Footer
            cancelBtnText="Cancel"
            confirmBtnText="Connect Bank Account"
            confirmBtnLoading={this.state.saving}
            onClose={this.handleCloseModal}
            onSubmit={this.save}
            disabled={!this.validator.allValid()}
          />
        </Modal>
      </div>
    )
  }
}

AddBankAccountModal.propTypes = {
  bankAccountAdded: PropTypes.bool.isRequired,
  route: PropTypes.string.isRequired,
  smaCountry: PropTypes.shape({
    countryCode: PropTypes.string.isRequired,
    currencyCode: PropTypes.string.isRequired,
  }).isRequired,
  checkImageUrl: PropTypes.string.isRequired,
}

export default AddBankAccountModal
